import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

export class BaseUrlInterceptor implements HttpInterceptor {

  constructor(private baseUrl: string) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      url: `${this.baseUrl.replace(/\/$/, '')}/${request.url}`
    });
    return next.handle(request);
  }
}
